import { render, staticRenderFns } from "./ModalCartAlert.vue?vue&type=template&id=65e39649&"
import script from "./ModalCartAlert.vue?vue&type=script&lang=js&"
export * from "./ModalCartAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports